export const POPUP_RESERVATION_BUTTON_SELECTOR = '.popup-btn-reservation'

export const ALL_GP_SELECTOR = [
    '.btn-gp',
    '.btn-and',
    '.btn-float.btn-gp',
    '.popup-btn-gp',
    `${POPUP_RESERVATION_BUTTON_SELECTOR}[data-store-type="gp"]`,
].join(',')

export const ALL_IOS_SELECTOR = [
    '.btn-ios',
    '.btn-float.btn-ios',
    '.popup-btn-ios',
    `${POPUP_RESERVATION_BUTTON_SELECTOR}[data-store-type="ios"]`,
].join(',')

export const SHOP_PRE_POPUP_SELECTOR = '.reservation-popup'
export const STORE_CONFIRM_POPUP_SELECTOR = '.store-confirm-popup'
export const STORE_COUNTDOWN_POPUP_SELECTOR = '.store-countdown-popup'
export const STORE_COUNTDOWN_TIMER_SELECTOR = '.countdown-timer'
export const ROLE_POPUP_HOST_SELECTOR = '.section-role'

export const PANGLE_POPUP = STORE_COUNTDOWN_POPUP_SELECTOR
export const PANGLE_BUTTONS = `${STORE_COUNTDOWN_POPUP_SELECTOR} .popup-btn-store`
export const PANGLE_GP_BUTTONS = `${STORE_COUNTDOWN_POPUP_SELECTOR} .popup-btn-gp`
export const PANGLE_IOS_BUTTONS = `${STORE_COUNTDOWN_POPUP_SELECTOR} .popup-btn-ios`
export const IGNORE_TRIGGER_PANGLE_BUTTONS = ''
